import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

export const Logo = ({ light = false, className = "" }) => {
  return (
    <Link to="/" className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <span className="grid h-8 w-8 place-items-center rounded-md bg-oath-ink shadow-sm">
        <ShieldCheck className="h-[18px] w-[18px] text-white" strokeWidth={2.25} />
      </span>
      <span className="flex flex-col leading-none">
        <span className={`font-display text-[17px] font-bold tracking-tight ${light ? "text-white" : "text-oath-ink"}`}>
          ResidenceProof
        </span>
        <span className={`font-mono-label text-[8px] mt-0.5 ${light ? "text-white/55" : "text-oath-muted"}`}>
          Residence &amp; Household Proof
        </span>
      </span>
    </Link>
  );
};

export default Logo;
